module.exports = __webpack_public_path__ + "static/img/7.cff6bee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/pengu/7.png
// module id = hoxf
// module chunks = 35